<template>
    <div class="recommendations">
        <div class="recommendations-title">
            <h3>Recommendations</h3>
        </div>
        <div class="recommendations-body">
            <div class="dish">
                <img src="../../assets/dish.png" alt="">
                <div class="dish-info">
                    <h3>Americano</h3>
                    <p>Traditional coffee drink. <br> 100% of Arabica. <br> 20/80 Coffee/Water</p>
                </div>
                <div class="dish-number" v-if="!editMode">
                    1
                </div>
                <div class="dish-remove" v-if="editMode">
                    <button class="remove" v-on:click="remove"></button>
                </div>
            </div>
            <div class="dish">
                <img src="../../assets/dish.png" alt="">
                <div class="dish-info">
                    <h3>Americano</h3>
                    <p>Traditional coffee drink. <br> 100% of Arabica. <br> 20/80 Coffee/Water</p>
                </div>
                <div class="dish-number" v-if="!editMode">
                    2
                </div>
                <div class="dish-remove" v-if="editMode">
                    <button class="remove" v-on:click="remove"></button>
                </div>
            </div>
            <!-- <div class="dish">
                <img src="../../assets/dish.png" alt="">
                <div class="dish-info">
                    <h3>Americano</h3>
                    <p>Traditional coffee drink. <br> 100% of Arabica. <br> 20/80 Coffee/Water</p>
                </div>
                <div class="dish-number" v-if="!editMode">
                    3
                </div>
                <div class="dish-remove" v-if="editMode">
                    <button class="remove" v-on:click="remove"></button>
                </div>
            </div> -->
        </div>
        <div class="recommendations-btn">
            <div class="edit-and-rearrange" v-if="!editMode">
                <button class="rearrange" v-on:click="rearrange">Rearrange</button>
                <button class="edit" v-on:click="edit">Edit</button>
            </div>

            <div class="recommendations-selects" v-if="addMode">
                <h3>Оберіть категорію</h3>
                <select>
                    <option>Пункт 1</option>
                    <option>Пункт 2</option>
                </select>
                <h3>Оберіть страву</h3>
                <select>
                    <option>Пункт 1</option>
                    <option>Пункт 2</option>
                </select>
            </div>

            <button class="add-recommendation" v-on:click="addRecommendation" v-if="editMode">+Add Recommendation</button>
            <button class="done" v-if="editMode">Done</button>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            editMode : false,
            addMode : false
        }
    },
    props: [

    ],
    methods: {
        rearrange(){

        },
        edit(){
            this.editMode = true;
        },
        remove(){

        },
        addRecommendation(){
            this.addMode = true;
        },
    },
}
</script>

<style scoped>
    .recommendations{
        width: 22.33vw;

        margin-right:2vw;
        display: block;
    }
    .recommendations-title h3 {
        margin-bottom: 0.6vw;
        font-weight: 500;
        font-size: 1.66vw;
        /* line-height: 29px; */

        color: #FFFFFF;
    }
    .recommendations-body {
        border: 0.06vw solid #CBD9E6;
        box-sizing: border-box;
        border-radius: 0.73vw;
        padding: 1vw;
        height: 18vw;

    }
    .dish {
        display: flex;

        position: relative;
        margin-bottom: 1.33vw;
    }
    .dish:nth-child(3){
        margin-bottom: 0;
    }
    .dish img {
        width: 4vw;
        height: 4vw;
        margin-right: 1vw;
        margin-top: 0.133vw;
    }
    .dish-info h3 {
        font-weight: 500;
        font-size: 1.33vw;
        line-height: 100%;
        margin-bottom: 0.2vw;

        color: #EDEDED;
    }
    .dish-info p {
        font-weight: 500;
        font-size: 0.73vw;
        line-height: 130.8%;

        color: #A4A3A1;
        margin-bottom: 0;
    }
    .dish-number {
        position: absolute;
        right: 0.33vw;
        top: 1.33vw;
        width: 2vw;
        height: 2vw;
        background: #1D1D1B;
        border-radius: 1vw;
        font-weight: 500;
        font-size: 1.33vw;
        line-height: 1.33vw;
        display: flex;
        align-items: center;

        justify-content: center;
        /* padding-right: 2px; */

        color: #EDEDED;

    }
    .remove {
        width: 2vw;
        height: 2vw;
        background: url("../../assets/delete.png") no-repeat center #E2223B;
        background-size: 1vw;
        border: 0;
        position: absolute;
        right: 0.33vw;
        top: 1.33vw;
        border-radius: 1.4vw;
        cursor: pointer;
        outline: none;
    }

    .edit-and-rearrange {
        display: flex;
        justify-content: center;
        margin-top: 2vw;
    }

    .edit-and-rearrange button {
        width: 10vw;
        height: 2.8vw;

        border: 0.06vw solid #A4A3A1;
        box-sizing: border-box;
        border-radius: 1.4vw;
        background: #464646;
        color: #fff;
        margin-right: 0.33vw;
        margin-left: 0.33vw;

        font-weight: 500;
        font-size: 1.33vw;
        /* line-height: 23px; */
        display: flex;
        justify-content: center;

        color: #A4A3A1;

        cursor: pointer;
        outline: none;
    }
    .add-recommendation {
        margin-top: 2vw;
        background: #464646 !important;
        width: 100% !important;
        height: 6vw !important;

        border: 0.06vw solid #CBD9E6 !important;
        box-sizing: border-box !important;
        border-radius: 0.73vw !important;
        font-weight: 500 !important;
        font-size: 1.6vw !important;
        /* line-height: 28px !important; */

        cursor: pointer;
        outline: none;
        color: #CBD9E6 !important;
    }
    .done {
        border: 0.06vw solid #129B81;
        box-sizing: border-box;
        border-radius: 1.4vw;
        width: 10vw;
        height: 2.8vw;
        font-weight: 500;
        font-size: 1.33vw;
        /* line-height: 23px; */
        margin-top: 2vw;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        outline: none;
        cursor: pointer;
        background: none;

        color: #129B81;
    }
    .recommendations-selects {
        margin-top: 0.5vw;
    }
    .recommendations-selects h3{
        font-family: Roboto;
        font-weight: 500;
        font-size: 1.33vw;
        /* line-height: 23px; */

        color: #C4C4C4;
    }
    .recommendations-selects select {
        outline: none;
        width: 100%;
        height: 2.66vw;
        background: #C4C4C4;
        border-radius: 0.33vw;

        font-family: Roboto;
        font-weight: 500;
        font-size: 1.3vww;
        /* line-height: 23px; */

        color: #262626;
        cursor: pointer;
    }
    .recommendations-selects h3 {
        margin-top: 0.66vw;
    }
</style>
